import { JDSMegaMenuProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSMegaMenuProps>
  ): React.FC<JDSMegaMenuProps> =>
  (props: JDSMegaMenuProps) => {
    if (!props.open || !props.items?.length) return null;
    return <Component {...props} />;
  };
